import {
  SurveyChildrenState,
  SurveyQueryState,
  SurveyReferenceState,
  BulkOperationState,
  SurveyState,
  SurveyStatePagination,
  ManageSurveyState,
  SupplierState,
} from './survey-state.model';
import { INITIAL_SURVEY_FILTERS } from '@ps/survey-utils';

export const QUOTAS_PAGE_LIMIT = 100;

export const INITIAL_SURVEY_PAGINATION: Readonly<SurveyStatePagination> = {
  page: 1,
  limit: 20,
  hasMore: true,
};

export const INITIAL_QUERY_STATE: SurveyQueryState = {
  surveys: [],
  counts: {},
  pagination: { ...INITIAL_SURVEY_PAGINATION },
  context: {
    targeting: 0,
    isMultiBuyerRequest: false,
    hasImpersonatedBuyer: false,
    mobile: false,
  },
  loadStatus: 'idle',
  error: null,
  filters: { ...INITIAL_SURVEY_FILTERS },
  sort: null,
  activeTabId: 'live',
  loadingSnapshot: null,
};

export const INITIAL_CHILDREN_STATE: SurveyChildrenState = {
  childSurveys: {},
  childSurveysCachedAt: {},
  childSurveyErrors: {},
};

export const INITIAL_REFERENCE_STATE: SurveyReferenceState = {
  buyerProjectManagers: [],
  operatorProjectManagers: [],
  transactionStatuses: [],
  buyerSettings: null,
  buyerPmCachedAt: null,
  operatorPmCachedAt: null,
  transactionStatusesCachedAt: null,
  buyerSettingsCachedAt: null,
  isDownloadingSurveyReport: false,
  isDownloadingSupplierSummary: false,
  isDownloadingCsReport: false,
};

export const INITIAL_BULK_OPERATION_STATE: BulkOperationState = {
  selected: [],
  stats: null,
  operation: null,
};

export const INITIAL_MANAGE_SURVEY_STATE: ManageSurveyState = {
  survey: null,
  childSurvey: null,
  childSurveyLoading: false,
  childSurveyError: null,
  loading: false,
  error: null,
  healthMetrics: [],
  healthMetricsLoading: false,
  healthMetricsError: null,
  remainingHours: null,
  remainingHoursLoading: false,
  remainingHoursError: null,
  activityLogs: [],
  activityLogsLoading: false,
  activityLogsError: null,
  quotas: [],
  quotasLoading: false,
  quotaTotal: 0,
  quotaLoadedPage: 0,
  quotasLoadingMore: false,
  quotaLockingIds: [],
  quotaSavingIds: [],
  trafficChannels: [],
  trafficChannelsLoading: false,
  trafficChannelsError: null,
  tcStatusChangingIds: [],
  creatingTrafficChannel: false,
  trafficChannelCreationError: null,
  psidUploadLoading: false,
  psidUploadError: null,
  psidUploadFilePath: null,
  psidUploadUniqCount: null,
  psidUploadTotalCount: null,
};

export const INITIAL_SUPPLIER_STATE: SupplierState = {
  allocations: [],
  allocationsLoading: false,
  allocationsError: null,
  allocationsUpdateStatus: 'idle',
  blends: [],
  blendsLoading: false,
  blendsError: null,
  flexibilityPriceParams: null,
  flexibilityPriceParamsLoading: false,
  flexibilityPriceParamsError: null,
};

// Convenience constant used by tests and effects specs.
export const INITIAL_SURVEY_STATE: SurveyState = {
  query: { ...INITIAL_QUERY_STATE },
  children: { ...INITIAL_CHILDREN_STATE },
  bulkOperation: { ...INITIAL_BULK_OPERATION_STATE },
  reference: { ...INITIAL_REFERENCE_STATE },
  manageSurvey: { ...INITIAL_MANAGE_SURVEY_STATE },
  supplier: { ...INITIAL_SUPPLIER_STATE },
};
